import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmdialogComponent } from './confirmdialog.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: ConfirmdialogComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class ConfirmRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/confirmdialog/confirm-routing.module.ts